import { render, staticRenderFns } from "./AdherenceIcon.vue?vue&type=template&id=067532ab&"
import script from "./AdherenceIcon.vue?vue&type=script&lang=js&"
export * from "./AdherenceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports